import { MarkerIcon } from "../shared/markers";
import { UiIcon } from "./Icon";
import { strings } from "./i18n";
import type { PartnerContact, PartnerMapContent } from "./types";
import styles from "./PartnerMap.module.scss";

interface ContactRowProps {
	content: PartnerMapContent;
	contact: PartnerContact;
	onContact: (channel: string) => void;
}

/** "Book & contact" of a restaurant or bar: the table, the phone, the website and the way there, in a row. It ends the Highlights and offers tabs. */
const ContactRow = ({ content, contact, onContact }: ContactRowProps) => {
	const { partner, base } = content;
	const t = strings(content.lang);
	return (
		<div className={styles.quick}>
			<a id="partnermap-contact-book" className={styles.book} href={contact.book} target="_blank" rel="noopener" onClick={() => onContact("book")}>
				<i>
					<MarkerIcon name="p_restaurant" size={18} />
				</i>
				{t.bookShort}
			</a>
			<a id="partnermap-contact-call" href={`tel:${partner.tel}`} onClick={() => onContact("call")}>
				<i>
					<UiIcon name="phone" />
				</i>
				{t.call}
			</a>
			<a id="partnermap-contact-website" href={partner.url} target="_blank" rel="noopener" onClick={() => onContact("website")}>
				<i>
					<UiIcon name="globe" />
				</i>
				{t.website}
			</a>
			<a id="partnermap-contact-directions" href={base.directionsUrl} target="_blank" rel="noopener" onClick={() => onContact("directions")}>
				<i>
					<UiIcon name="directions" />
				</i>
				{t.directions}
			</a>
		</div>
	);
};

export default ContactRow;
